
import Application from '@package/app';
import version from '@package/version';
import { Notifications } from '@package/notifications';
import socket, { connect as socketConnect }  from '@package/socket';
import { name as navigateWrapperReducerName, reducer as navigateWrapperReducer } from '@wrapper/navigate';

import ReactDOM from 'react-dom/client';
import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider, useDispatch } from 'react-redux';

import routes from './configs/routes';
import navigate from './configs/navigate';
import { create as createStore, getReducersFromRoutes } from './store';

import './styles/index.module.scss';


(async function() {
  try {

    socket(window.env['SOCKET_HOST'], {
      path: window.env['SOCKET_PATH'],
    });
    socketConnect();

    const moduleReducers = await getReducersFromRoutes(routes);
    const redux = createStore({
      ...moduleReducers,
      [navigateWrapperReducerName]: navigateWrapperReducer,
    });

    const app = new Application({
      routes,
      navigate,
      wrappers: {
        default: import(/* webpackChunkName: "wrapper-default" */'@wrapper/default'),
        empty: import(/* webpackChunkName: "wrapper-default" */'@wrapper/empty'),
        navigate: import(/* webpackChunkName: "wrapper-navigate" */'@wrapper/navigate'),
      },
      exclude: {
        routes: [
          '/offer',
          '/sign-up',
          '/set/password',
          '/reset/password',
        ],
      }
    });

    const App = app.render();

    const Checker = () => {
      const dispatch = useDispatch();

      useEffect(() => {
        version.middleware(dispatch);
        version.start();
      }, [dispatch]);

      return null;
    }

    const root = ReactDOM.createRoot(document.querySelector('#root'));
    root.render((
      <Provider store={redux.store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
        <Checker/>
        <Notifications />
      </Provider>
    ));

    version.start();
  }
  catch (error) {

  }
})();
